import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';

interface SkeltonProps {
  height: number;
}
export default function SkeletonLoader({ height }: SkeltonProps) {
  return (
    <Stack spacing={1}>
      <Skeleton
        variant='text'
        width='100%'
        height={height}
      />
    </Stack>
  );
}
